import { MouseEvent, useMemo } from 'react';

const EMAIL_PARTS = {
  user: 'contact',
  domain: 'mmsoftware',
  tld: 'co',
};

export interface EmailLinkProps {
  className?: string;
  children?: React.ReactNode;
}

export function EmailLink({ className = '', children }: EmailLinkProps) {
  const email = useMemo(() => {
    return `${EMAIL_PARTS.user}@${EMAIL_PARTS.domain}.${EMAIL_PARTS.tld}`;
  }, []);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (typeof window !== 'undefined') {
      window.location.href = `mailto:${email}`;
    }
  };

  return (
    <a
      href="#"
      onClick={handleClick}
      className={className}
      aria-label={email}
    >
      {children ? (
        children
      ) : (
        <span>
          {EMAIL_PARTS.user}
          <span aria-hidden="true">@</span>
          {EMAIL_PARTS.domain}
          <span aria-hidden="true">.</span>
          {EMAIL_PARTS.tld}
        </span>
      )}
    </a>
  );
}
